<!--
  Generated template for the TextContactPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->

<ion-header>
  <ion-toolbar class="shadow">
      <ion-buttons slot="start" *ngIf="previousUrl">
        <ion-back-button [defaultHref]="previousUrl" (click)="navCtrl.back()"></ion-back-button>
      </ion-buttons>
      <ion-title>
        <!-- <div style="padding-top:15px;padding-bottom:15px;"> -->
          {{ "MYSPORT_USER_PROFILE_SUPPORT_BTN" | translate }}
        <!-- </div> -->
      </ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
  <div class="content-padding">
    {{ "CONTACT_ISSUES" | translate }}
  </div>

  <ion-list class="ion-no-padding">
    <ion-item button (click)="sendMail()">
      <ion-icon slot="start" name="mail"></ion-icon>
      {{ "CONTACT_SEND_MAIL" | translate }}
    </ion-item>
  </ion-list>

  <ion-list class="ion-no-padding">
    <ion-list-header class="ion-text-start">
      {{ "CONTACT_TECHNICAL_DETAILS" | translate }}
    </ion-list-header>
    <ion-item>
      {{ "CONTACT_VERSION" | translate }}
      <ion-note slot="end">{{ buildInfo.version }}</ion-note>
    </ion-item>
    <ion-item>
      {{ "CONTACT_RELEASE_DATE" | translate }}
      <ion-note slot="end">{{ buildInfo.lm | date: pipeDateFormat }}</ion-note>
    </ion-item>
  </ion-list>

</ion-content>